import { createAction } from 'redux-actions';

export const onDeletedReportTemplate = createAction(
  'ON_DELETED_REPORT_TEMPLATE'
);

export const resetDeleteReportTemplate = createAction(
  'RESET_DELETE_REPORT_TEMPLATE'
);
